import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import moment from 'moment';
import numeral from 'numeral';
import { formatDatePartialFormat } from '@widergy/web-utils/lib/date';
import { UTLabel } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';

import styles from './styles';
import stylesSCSS from './styles.module.scss';

const renderPeriodInfo = (description, value) => (
  <div className={stylesSCSS.periodInfo}>
    <UTLabel>{description}</UTLabel>
    <UTLabel semibold primary>
      {value}
    </UTLabel>
  </div>
);

function BillDetails({ bill, keys }) {
  return (
    <div style={styles.container}>
      <UTLabel bold>
        {`${message('AccountStatus:periodDetail')} ${formatDatePartialFormat(bill.period)}`}
      </UTLabel>
      <div style={styles.dateDetails}>
        <div style={styles.periodDate}>
          <UTLabel darkGray small>
            {message('AccountStatus:periodStartedOn')}
          </UTLabel>
          <UTLabel semibold primary>
            {moment(bill.period_started_on).format('L')}
          </UTLabel>
        </div>
        <div style={styles.periodDate}>
          <UTLabel darkGray small>
            {message('AccountStatus:periodEndedOn')}
          </UTLabel>
          <UTLabel semibold primary>
            {moment(bill.period_ended_on).format('L')}
          </UTLabel>
        </div>
      </div>
      {keys.firstKey && keys.unit && renderPeriodInfo(keys.firstName, `${bill[keys.firstKey]} ${keys.unit}`)}
      {keys.secondKey &&
        keys.unit &&
        renderPeriodInfo(keys.secondName, `${bill[keys.secondKey]} ${keys.unit}`)}
      {keys.thirdKey && keys.unit && renderPeriodInfo(keys.thirdName, `${bill[keys.thirdKey]} ${keys.unit}`)}
      {renderPeriodInfo(message('AccountStatus:dateOfIssue'), moment(bill.issued_on).format('L'))}
      {renderPeriodInfo(message('AccountStatus:dueDate'), moment(bill.first_expiration_on).format('L'))}
      <div className={`${stylesSCSS.periodInfo} ${stylesSCSS.totalAmount}`}>
        <UTLabel white>{message('AccountStatus:amount')}</UTLabel>
        <UTLabel white semibold>
          {numeral(bill.amount).format('$0,0.[00]')}
        </UTLabel>
      </div>
    </div>
  );
}

BillDetails.propTypes = {
  bill: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  keys: PropTypes.shape({
    firstKey: PropTypes.string,
    firstName: PropTypes.string,
    secondKey: PropTypes.string,
    secondName: PropTypes.string,
    thirdKey: PropTypes.string,
    thirdName: PropTypes.string,
    unit: PropTypes.string
  }).isRequired
};

export default Radium(BillDetails);
